import { render, staticRenderFns } from "./EMelderComponentMeldenBs9GlobaleAuswahlListe.vue?vue&type=template&id=de5094b0"
import script from "./EMelderComponentMeldenBs9GlobaleAuswahlListe.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs9GlobaleAuswahlListe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports